import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { FieldArray as ReactFieldArray } from '@rexlabs/react-forms';
import { PrimaryIconButton, OutlineButton } from '@rexlabs/button';
import AddIcon from '@rexlabs/icons/add.svg';
import CloseIcon from '@rexlabs/icons/close-large.svg';
import Field from './field';

function DefaultFieldArray(_ref) {
  var fields = _ref.fields,
      push = _ref.push,
      getFieldProps = _ref.getFieldProps;
  var token = useToken();
  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    sy: token('spacing.s')
  }, _mapInstanceProperty(fields).call(fields, function (field, index) {
    var fieldProps = getFieldProps(field);
    var actions = field.actions;
    return /*#__PURE__*/React.createElement(Box, {
      key: fieldProps.id,
      alignItems: "flex-end"
    }, /*#__PURE__*/React.createElement(Box, {
      flex: 1
    }, /*#__PURE__*/React.createElement(Field, _extends({}, fieldProps, {
      label: index === 0 ? field.label : null,
      fullWidth: true
    }))), /*#__PURE__*/React.createElement(Box, {
      flex: 0,
      alignItems: "center",
      ml: token('spacing.s')
    }, /*#__PURE__*/React.createElement(PrimaryIconButton, {
      Icon: CloseIcon,
      onClick: function onClick() {
        var _actions$remove;

        actions === null || actions === void 0 ? void 0 : (_actions$remove = actions.remove) === null || _actions$remove === void 0 ? void 0 : _actions$remove.call(actions);
      }
    })));
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 0
  }, /*#__PURE__*/React.createElement(OutlineButton, {
    IconLeft: AddIcon,
    onClick: function onClick() {
      return push();
    }
  }, "Add another")));
}

function FieldArray(_ref2) {
  var children = _ref2.children,
      render = _ref2.render,
      props = _objectWithoutProperties(_ref2, ["children", "render"]);

  return /*#__PURE__*/React.createElement(ReactFieldArray, props, children || render || function (state) {
    return /*#__PURE__*/React.createElement(DefaultFieldArray, state);
  });
}

export default FieldArray;